import React, { useState, useEffect } from "react";
import { Auth } from "aws-amplify";
import Navbar from "react-bootstrap/Navbar";
import { AppContext } from "./libs/contextLib";
import { useHistory } from "react-router-dom";
import "./App.css";
import Routes from "./Routes";
import Nav from "react-bootstrap/Nav";
import { onError } from "./libs/errorLib";
import {  MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Box from '@material-ui/core/Box';


//import LogoutIcon from '@material-ui/icons/Logout';
import iLogo from "./images/logo_tm.png";
import pinIcon from'./images/pin.svg';


import { LinkContainer } from "react-router-bootstrap";


const theme = createTheme({
  typography: {
    fontFamily: [
      'Montserrat'
    ].join(','),
  },
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#10385A',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {

      main: '#6666CC',//'#F18C7E',
      // dark: will be calculated from palette.secondary.main,
    },
    // error: will use the default color
  },
});



function App() {
  const [isAuthenticated, userHasAuthenticated] = useState(false);
  const [isCampra, userIsCampra] = useState(false);
  const [userName, setUserName] = useState("");
  const [showSites, setShowSites] = useState(false);
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const [expanded, setExpanded] = useState(false);
  const history = useHistory();

  let listener = null


  useEffect(() => {
    onLoad();
  }, []);

  useEffect(() => {
    listener = document.addEventListener("scroll", e => {
      setExpanded(false);
    })
    return () => {
      document.removeEventListener("scroll", listener)
    }
  }, [])




  async function onLoad() {
    try {
      await Auth.currentSession();
      const cui = await Auth.currentUserInfo();
      setUserName(cui.attributes['custom:name']);
      userIsCampra(cui.attributes['custom:name']==="CAMpRA" && cui.attributes.email.length==21 && cui.attributes.email.includes("pra@aires"));
      userHasAuthenticated(true);
    }
    catch(e) {
      if (e !== 'No current user') {
        onError(e);
      }
    }

    setIsAuthenticating(false);
  }


  const useViewport = () => {
    const [width, setWidth] = React.useState(window.innerWidth);

    React.useEffect(() => {
      const handleWindowResize = () => setWidth(window.innerWidth);
      window.addEventListener("resize", handleWindowResize);
      return () => window.removeEventListener("resize", handleWindowResize);
    }, []);

    // Return the width so we can use it in our components
    return { width };
  }

  const { width } = useViewport();
  const breakpoint = 768;

  async function handleLogout() {
    await Auth.signOut();
    userHasAuthenticated(false);
    userIsCampra(false);
    history.push("/");
  }
  function handleAccount(event) {
    event.preventDefault();
    history.push("/account");
    setExpanded(false);
  }
  function handleHub(event) {
    event.preventDefault();
    history.push("/");
    setExpanded(false);
  }  
  
  function handleManager(event) {
    event.preventDefault();
    history.push("/management");
    setExpanded(false);
  }

  function handleQX(event) {
    event.preventDefault();
    history.push("/qx");
    setExpanded(false);
  }
  function handleFT1(event) {
    event.preventDefault();
    history.push("/finetuner1");
    setExpanded(false);
  }
  function handleNTABS(event) {
    event.preventDefault();
    history.push("/ntabs");
    setExpanded(false);
  }
  function handleAbout(event) {
    event.preventDefault();
    history.push("/about");
    setExpanded(false);
  }
  function handleLogin(event) {
    event.preventDefault();
    history.push("/login");
    setExpanded(false);

  }
  function handleSignup(event) {
    event.preventDefault();
    history.push("/signup");
    setExpanded(false);
  }

  function handleThinking(event) {
    event.preventDefault();
    history.push("/hosting");
    setExpanded(false);
  }
  return (
    !isAuthenticating && (
      <MuiThemeProvider theme={theme}>
       <CssBaseline/>
      <div className={width>breakpoint?"container":"mobile-container"} >
        <Navbar  collapseOnSelect  expanded={expanded} bg="light" variant="light" expand="md" className="mb-3" style={{left:0, paddingLeft: 0, paddingRight: 0, paddingBottom: 6, paddingTop: 8, borderBottom: '5px solid #10385A'}}>
          <LinkContainer to="/">
            <Navbar.Brand  onClick={() => setExpanded(expanded ? false : "")}>
            <img
              src={iLogo}
              width="auto"
              height="28"
              style={width>breakpoint?{}:{marginLeft: 16}}
              className="d-inline-block align-top"
              alt="FinDigAI"
              />

            </Navbar.Brand>


          </LinkContainer>

          <Navbar.Toggle style={width>breakpoint?{}:{marginRight: 16}}   onClick={() => setExpanded(expanded ? false : "expanded")} onBlur={() => setExpanded(false)}/>
          <Navbar.Collapse className="justify-content-end" >
              {isAuthenticated ?
                (isCampra ?
                <Nav activeKey={window.location.pathname} onClick={() => setExpanded(false)} onBlur={() => setExpanded(false)}>
                <Nav.Link className={width>breakpoint?"":"ml-auto"} style={width>breakpoint?{}:{marginLeft: 16, marginRight: 22}} onMouseDown={handleAccount} onBlur={() => setExpanded(false)}>
                <Box display="flex" justifyContent="center" alignItems="center" flexWrap="nowrap" whiteSpace="nowrap">
                <span class="material-icons-round" style={{ color: "#555", fontSize: "16px"}}>
                  account_circle
                </span>
                &nbsp;{userName}
                </Box>
                </Nav.Link>
                <Nav.Link className={width>breakpoint?"":"ml-auto"} style={width>breakpoint?{}:{marginLeft: 16, marginRight: 22}} onMouseDown={handleLogout}>
                <Box display="flex" justifyContent="center" alignItems="center" flexWrap="nowrap" whiteSpace="nowrap">
                &nbsp;Logout
                </Box>
                </Nav.Link>
                </Nav>
               :
                <Nav activeKey={window.location.pathname} onClick={() => setExpanded(false)} onBlur={() => setExpanded(false)}>
                <Nav.Link className={width>breakpoint?"":"ml-auto"} style={width>breakpoint?{}:{marginLeft: 16, marginRight: 22}} onMouseDown={handleAccount} onBlur={() => setExpanded(false)}>
                <Box display="flex" justifyContent="center" alignItems="center" flexWrap="nowrap" whiteSpace="nowrap">
                <span class="material-icons-round" style={{ color: "#555", fontSize: "16px"}}>
                  account_circle
                </span>
                &nbsp;{userName}
                </Box>
                </Nav.Link>
                <Nav.Link className={width>breakpoint?"":"ml-auto"} style={width>breakpoint?{}:{marginLeft: 16, marginRight: 22}} onMouseDown={handleManager}>
                <Box display="flex" justifyContent="center" alignItems="center" flexWrap="nowrap" whiteSpace="nowrap">
                &nbsp;Manager
                </Box>
                </Nav.Link>
                <Nav.Link className={width>breakpoint?"":"ml-auto"} style={width>breakpoint?{}:{marginLeft: 16, marginRight: 22}} onMouseDown={handleHub}>
                <Box display="flex" justifyContent="center" alignItems="center" flexWrap="nowrap" whiteSpace="nowrap">
                &nbsp;Projects Hub
                </Box>
                </Nav.Link>
                <Nav.Link className={width>breakpoint?"":"ml-auto"} style={width>breakpoint?{}:{marginLeft: 16, marginRight: 22}} onMouseDown={handleQX}>
                <Box display="flex" justifyContent="center" alignItems="center" flexWrap="nowrap" whiteSpace="nowrap">
                &nbsp;QX
                </Box>
                </Nav.Link>               
                <Nav.Link className={width>breakpoint?"":"ml-auto"} style={width>breakpoint?{}:{marginLeft: 16, marginRight: 22}} onMouseDown={handleFT1}>
                <Box display="flex" justifyContent="center" alignItems="center" flexWrap="nowrap" whiteSpace="nowrap">
                &nbsp;FT-stage1
                </Box>
                </Nav.Link>
                <Nav.Link className={width>breakpoint?"":"ml-auto"} style={width>breakpoint?{}:{marginLeft: 16, marginRight: 22}} onMouseDown={handleNTABS}>
                <Box display="flex" justifyContent="center" alignItems="center" flexWrap="nowrap" whiteSpace="nowrap">
                &nbsp;NTABS
                </Box>
                </Nav.Link>
                <Nav.Link className={width>breakpoint?"":"ml-auto"} style={width>breakpoint?{}:{marginLeft: 16, marginRight: 22}} onMouseDown={handleLogout}>
                <Box display="flex" justifyContent="center" alignItems="center" flexWrap="nowrap" whiteSpace="nowrap">
                &nbsp;Logout
                </Box>
                </Nav.Link>
                </Nav>

              ) : (
                <Nav  activeKey={window.location.pathname} onClick={() => setExpanded(false)} onBlur={() => setExpanded(false)}>
                  <Nav.Link className={width>breakpoint?"":"ml-auto"} style={width>breakpoint?{}:{marginLeft: 16, marginRight: 22}} onMouseDown={handleAbout} onBlur={() => setExpanded(false)}>
                  <Box display="flex" justifyContent="center" alignItems="center" flexWrap="nowrap" whiteSpace="nowrap">
                  &nbsp;About
                  </Box>
                  </Nav.Link>
                  <Nav.Link className={width>breakpoint?"":"ml-auto"} style={width>breakpoint?{}:{marginLeft: 16, marginRight: 22}} onMouseDown={handleSignup}>
                  <Box display="flex" justifyContent="center" alignItems="center" flexWrap="nowrap" whiteSpace="nowrap">
                  &nbsp;Signup
                  </Box>
                  </Nav.Link>
                  <Nav.Link className={width>breakpoint?"":"ml-auto"} style={width>breakpoint?{}:{marginLeft: 16, marginRight: 22}} onMouseDown={handleLogin}>
                  <Box display="flex" justifyContent="center" alignItems="center" flexWrap="nowrap" whiteSpace="nowrap">
                  &nbsp;Login
                  </Box>
                  </Nav.Link>
                </Nav>
              )}

          </Navbar.Collapse>
        </Navbar>

        <AppContext.Provider value={{ isAuthenticated, userHasAuthenticated, isCampra, userIsCampra, showSites, setShowSites, userName, setUserName}}>
          <Routes />
        </AppContext.Provider>
      </div>
      </MuiThemeProvider>
    )
  );
}

export default App;
